import type { AutoTradeHistoryDrawerProps } from '@bo-components/autoTradeHistoryDrawer/AutoTradeHistoryDrawer';
import type { GamePlayerProjectionScore } from '@library/types/scoring';
import type { GamePlayerProjectionTrading } from '@library/types/trading';
import type { PlayerDescriptors } from '@library/types/player';
import { formatDate } from '@library/component-utils/dateTime';
import { useState } from 'react';

export function useAutoTradeHistoryDrawerProps() {
  const defaultAutoTradeHistoryDrawerProps: Omit<
    AutoTradeHistoryDrawerProps,
    'onCancelDrawer'
  > = {
    drawerOpen: false,
    durationId: '',
    fromDateString: '',
    gameDescriptor: '',
    gameId: '',
    leagueId: undefined,
    playerId: undefined,
    playerImage: '',
    playerName: '',
    position: ''
  };
  const [autoTradeHistoryDrawerProps, setAutoTradeHistoryDrawerProps] =
    useState<Omit<AutoTradeHistoryDrawerProps, 'onCancelDrawer'>>(
      defaultAutoTradeHistoryDrawerProps
    );

  const {
    drawerOpen,
    durationId,
    fromDateString,
    gameDescriptor,
    gameId,
    leagueId,
    playerId,
    playerImage,
    playerName,
    position
  } = autoTradeHistoryDrawerProps;

  const handleSelectAutoTradeHistory = ({
    gameStartDateTime,
    newPlayerDescriptors,
    newProjection
  }: {
    gameStartDateTime: string;
    newPlayerDescriptors: PlayerDescriptors;
    newProjection: GamePlayerProjectionTrading | GamePlayerProjectionScore;
  }) => {
    const {
      description: newDescription,
      durationId: newDurationId,
      gameId: newGameId,
      leagueId: newLeagueId,
      playerId: newPlayerId,
      position: newPosition
    } = newProjection;

    const newGameDescriptor = `@${newDescription} | ${formatDate({ date: gameStartDateTime, pattern: 'EEE, MMM d' })}`;

    setAutoTradeHistoryDrawerProps({
      drawerOpen: true,
      durationId: newDurationId ?? '',
      gameDescriptor: newGameDescriptor,
      gameId: newGameId ?? '',
      fromDateString: gameStartDateTime,
      leagueId: newLeagueId,
      playerId: newPlayerId ?? '',
      playerImage: newPlayerDescriptors.playerImage ?? '',
      playerName: newPlayerDescriptors.playerName ?? '',
      position: newPosition ?? ''
    });
  };

  const onCancelAutoTradeHistoryDrawerModal = () => {
    setAutoTradeHistoryDrawerProps(defaultAutoTradeHistoryDrawerProps);
  };

  return {
    drawerOpen,
    durationId,
    fromDateString,
    gameDescriptor,
    gameId,
    handleSelectAutoTradeHistory,
    leagueId,
    onCancelAutoTradeHistoryDrawerModal,
    playerId,
    playerImage,
    playerName,
    position
  };
}
